import React from 'react';

/** Country for the missions payload. A session also shows its ordinal in the event. */
export default function MissionReportFields({ scopeId, country, sessionNumber, disabled, onChange }) {
  return (
    <div className="custom-reports-flag-row">
      <label className="custom-reports-field" htmlFor={`custom-report-country-${scopeId}`}>
        <span>Country</span>
        <input
          id={`custom-report-country-${scopeId}`}
          className="custom-reports-control"
          value={country}
          placeholder="Djibouti"
          onChange={(e) => onChange({ country: e.target.value })}
          disabled={disabled}
        />
      </label>
      {sessionNumber != null && (
        <label className="custom-reports-field custom-reports-field-day">
          <span>Session</span>
          <input className="custom-reports-control" value={sessionNumber} readOnly />
        </label>
      )}
    </div>
  );
}
